import React, { useEffect, useState } from 'react';

const left = (end) => Math.max(0, new Date(end).getTime() - Date.now());

const Cell = ({ v, label, accent }) => (
  <div className="flex flex-col items-center min-w-[54px] rounded-lg bg-white/10 backdrop-blur-sm border border-white/15 px-2.5 py-2">
    <span className="font-mono text-[22px] sm:text-[26px] font-semibold tabular-nums leading-none" style={{ color: accent }}>{String(v).padStart(2, '0')}</span>
    <span className="text-[9.5px] tracking-[0.2em] uppercase text-white/60 mt-1">{label}</span>
  </div>
);

export const Countdown = ({ endsAt, accent }) => {
  const [ms, setMs] = useState(() => left(endsAt));
  useEffect(() => {
    const h = setInterval(() => setMs(left(endsAt)), 1000);
    return () => clearInterval(h);
  }, [endsAt]);
  if (ms <= 0) return null;
  const s = Math.floor(ms / 1000);
  return (
    <div data-testid="seasonal-countdown" className="mt-6">
      <div className="text-[11px] tracking-[0.3em] uppercase text-white/70 mb-2">Ends in</div>
      <div className="flex gap-2">
        <Cell v={Math.floor(s / 86400)} label="Days" accent={accent} />
        <Cell v={Math.floor((s % 86400) / 3600)} label="Hours" accent={accent} />
        <Cell v={Math.floor((s % 3600) / 60)} label="Mins" accent={accent} />
        <Cell v={s % 60} label="Secs" accent={accent} />
      </div>
    </div>
  );
};
